/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Orders_Review_Color_GreenInputs */

const en_orders_review_color_green = /** @type {(inputs: Orders_Review_Color_GreenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Green`)
};

const es_orders_review_color_green = /** @type {(inputs: Orders_Review_Color_GreenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verde`)
};

/**
* | output |
* | --- |
* | "Green" |
*
* @param {Orders_Review_Color_GreenInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const orders_review_color_green = /** @type {((inputs?: Orders_Review_Color_GreenInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Orders_Review_Color_GreenInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_orders_review_color_green(inputs)
	return es_orders_review_color_green(inputs)
});